import JsonResponse from "csi/comm/JsonResponse";
import PostRequest from "csi/comm/PostRequest";
import BooleanController from "csi/heading/BooleanController";
import locale from "csi/locale";
import csi from "csi/main";
import { C8Node } from "csi/typings";
import MessageDialog from "csi/widget/MessageDialog";
import xml from "csi/xml";
import declare from "dojo/_base/declare";

const CheckSamplesAndQuotes = declare(BooleanController, {
	/**
	 * When a ProductSource or Colorway is inactivated - if there are samples and quotes in the ProductSource or associated to this Colorway set to change state or status, a confirmation dialog will open
	 * @override
	 */
	process() {
		const currentNode = this.getNode();
		if (this.isNotStyleProduct(currentNode)) {
			return this.inherited(arguments);
		}
		const active = this._getCheckboxValue();
		if (!active) {
			const isActionInactivateColorway = this.m_action.m_id === "InactivateColorway";

			const dfd = isActionInactivateColorway ? 
				new PostRequest("Apparel", "ColorwayAssociatedToSamplesAndQuotesForStateChange")
					.addParameter(xml.PROP_URL, this.m_urlNode)
					.post() : 
				new PostRequest("Sourcing", "ContainsSamplesAndQuotesForStateChange")
					.addParameter(xml.PROP_URL, this.m_urlNode)
					.post();

			this.when(dfd, (response: JsonResponse) => {
				// return value from operation contains [String of boolean value, String, String of boolean value]
				const res = response.getReturnValue();
				if (res[0] == "false" && res[2] == "false") {
					return BooleanController.prototype.process.call(this);
				}
				let confirmationString = "";
				if (res[0] == "true") {
					confirmationString += isActionInactivateColorway ? locale.typeAction("Colorway", "InactivateColorway_ChangeSampleStatus") + res[1] + "\n" : locale.typeAction("ProductSource", "InactivateProductSource_ChangeSampleStatus") + res[1] + "\n";
				}
				if (res[2] == "true") {
					confirmationString += isActionInactivateColorway ? locale.typeAction("Colorway", "InactivateColorway_ChangeQuoteStatus") : locale.typeAction("ProductSource", "InactivateProductSource_ChangeQuoteStatus");
				}
				confirmationString = confirmationString.trim();

				this.confirmAction({
					title: isActionInactivateColorway ? locale.resource("InactivateColorway") : locale.resource("InactivateProductSource"),
					buttons: ["INACTIVATE", MessageDialog.BUTTON_CANCEL],
					message: confirmationString,
					onResponse: (key: string) => {
						if (key == "INACTIVATE") {
							BooleanController.prototype.process.call(this);
						} else {
							this.postProcess();
						}
					},
				});
			});
		} else {
			BooleanController.prototype.process.call(this);
		}
	},

	/**
	 * Check if we are on style
	 * @param currentNode 
	 * @returns boolean checking if not on style Product
	 */
	isNotStyleProduct(currentNode: C8Node): boolean {
		const isProductSource = currentNode?.$Type === "ProductSource";
		const isNotStyleSourcing = this.getCache().getNode(currentNode.__Parent__)?.$Type !== "StyleSourcing";
		return currentNode !== undefined && isProductSource && isNotStyleSourcing;
	},
});

export = CheckSamplesAndQuotes;
